import { DEFAULT_CITY } from "ultra/const/general";

export function hasCityFilterForSource(filters, city, source) {
    return Boolean(city && filters[city] && filters[city][source]);
}

export function getFilter(filters, city, source) {
    return filters?.[city]?.[source] || filters?.[DEFAULT_CITY]?.[source];
}
